import { render, staticRenderFns } from "./ReleaseBundleList.vue?vue&type=template&id=20c7d7de&scoped=true"
import script from "./ReleaseBundleList.vue?vue&type=script&lang=js"
export * from "./ReleaseBundleList.vue?vue&type=script&lang=js"
import style0 from "./ReleaseBundleList.vue?vue&type=style&index=0&id=20c7d7de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c7d7de",
  null
  
)

export default component.exports